
const digest = 'e4006135725161b3fcd60127a6a05bf2d9688b29f42222095e1c6bbc092c8251';
const classes = {"wrapper":"_wrapper_16lwy_1","item":"_item_16lwy_7","active":"_active_16lwy_28"};
const css = `._wrapper_16lwy_1 {
  display: flex;
  gap: 10px;
  align-items: center;
}

._item_16lwy_7 {
  width: 35px;
  height: 35px;
  font-size: 15px;
  border: 1px solid #e9f2fa;
  border-radius: 6px;
  background: #f3f3f3;
  color: #000000;
  cursor: pointer;
  font-weight: 600;
  transition: 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

._item_16lwy_7:hover {
  color: #000000;
  background: #e9f2fa;
}

._active_16lwy_28, ._active_16lwy_28:hover {
  background: #1d65d8;
  border-color: #1d65d8;
  color: #fff;
  transform: scale(1.2);
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  